<template>
    <div class="mediaBox mt10" v-if="mediaList">
        <h3 class="columnTit"><span>推荐媒体</span></h3>
        <div class="mediaSwiper">
            <el-carousel height="274px" indicator-position="outside" :autoplay="false" arrow="always">
                <el-carousel-item v-for="(item,i) in mediaList" :key="i">
                    <ul class="mediaList">
                        <li v-for="(con,k) in item" :key="k">
                            <a :href="'https://auction.artron.net/meiti/index.php?MagazineCode='+con.neCode" target="_blank" :title="con.title">
                                <div class="imgBox">
                                    <el-image
                                        style="width: 100%; height: 100%;"
                                        :src="con.picture"
                                        fit="cover">
                                        <div slot="placeholder" class="image-slot">
                                            加载中<span class="dot">...</span>
                                        </div>
                                        <div slot="error" class="el-image__error">
                                            <img src="@/assets/imgs/placeholder-logo.png" alt="" style="width:80%;height:80%;object-fit: contain;">
                                        </div>
                                    </el-image>
                                </div>
                                <div class="name">{{con.title}}</div>
                            </a>
                        </li>
                    </ul>
                </el-carousel-item>
            </el-carousel>
        </div>
    </div>
</template>

<script>
export default {
    props:['mediaList'],
    name: "IndexMedia"
}
</script>

<style scoped lang="scss">
/*推荐媒体*/
.mediaSwiper{position: relative;
    /deep/.el-carousel--horizontal{padding-top: 50px;margin-top: -50px;}
    /deep/.el-carousel__indicators--outside{
        position: absolute;top:3px;right:74px;left:inherit;
        .el-carousel__indicator--horizontal{padding:0;margin-left: 10px;
            .el-carousel__button{width:8px;height:8px;border-radius: 50%;background-color: #F2F2F2;opacity: 1;}
        }
        .el-carousel__indicator.is-active button{background-color: #329D15;}
    }
    /deep/.el-carousel__arrow{width:20px;height:20px;background-color: #329d15;top:-46px;transform:translateY(0);display:block!important;}
    /deep/.el-carousel__arrow:hover{background-color: #5BB144;}
    /deep/.el-carousel__arrow--left{left:inherit;right:34px;}
    /deep/.el-carousel__arrow--right{right:0;}
    .mediaList{
        ul{overflow: hidden;}
        li{width:180px;float:left;margin-right: 20px;
            .imgBox{width:180px;height:240px;overflow: hidden;border-radius: 4px;}
            .name{margin-top: 10px;font-size: 16px;line-height: 24px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;text-align: center;}
        }
        li:last-child{margin-right: 0;}
    }
}
</style>